import { FETCH_CLIENT } from '../actions/clientActions';
import { defaultClientContext } from '../contexts/Client/Client';
import { ClientContextType } from '../contexts/Client/types';

export type ClientReducerActionType = {
  type: string;
  payload: ClientContextType;
};

const clientReducer = (
  state = defaultClientContext,
  action: ClientReducerActionType
) => {
  switch (action.type) {
    case FETCH_CLIENT:
      return action.payload;
    default:
      return state;
  }
};

export default clientReducer;
